import type { FC } from 'react'

import { Select } from '@skytech/ui'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import { useSearchParamsByKey } from '@/hooks/searchParams'
import type { TradeInOrderCounter } from '@/modules/admin/resources'

export const StatusSelect: FC<{ orderCounter: TradeInOrderCounter }> = ({ orderCounter }) => {
  const translate = useTranslation()
  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status')

  const statusOptions = Object.keys(orderCounter).map(orderStatus => ({
    value: orderStatus,
    label: translate(`trade_in_order_status/${orderStatus}`),
  }))

  return (
    <Select
      id="status-dropdown"
      className="flex md:hidden"
      marginBottom={18}
      value={queryStatus || ''}
      label={<Translation id="Select status" />}
      options={statusOptions}
      onChange={status => {
        if (!status) return
        if (typeof status.value !== 'string') throw Error('Incorrect status!')
        setQueryStatus(status.value)
      }}
    />
  )
}
